import { FC } from 'react';
import { Breadcrumb, BreadcrumbItem } from '../breadcrumb/breadcrumb';
import styles from './styles.module.css';

interface PageBannerProps {
  titleBread?: string;
  showBreadcrumb?: boolean;
  breadcrumbs?: BreadcrumbItem[];
  useCurrentRoute?: boolean;
  title?: string;
  className?: string;
}

export const PageBanner: FC<PageBannerProps> = ({
  breadcrumbs = [],
  useCurrentRoute = true,
  title,
  className,
}) => {
  const defaultBreadcrumbs = breadcrumbs.length > 0 ? breadcrumbs : undefined;

  return (
    <div className={className}>
      <div className={styles.pageBanner}>
        <div className={styles.breadcrumbContainer}>
          <Breadcrumb
            items={defaultBreadcrumbs}
            useCurrentRoute={useCurrentRoute}
            titleBread={title}
          />
        </div>
        <h1 className={styles.title}>{title}</h1>
      </div>
    </div>
  );
};
